import React/*, {useState}*/ from 'react';
import { createReactEditorJS } from 'react-editor-js';
import {consoleLog} from '../../../utils/functions';

import './blocks.css';

const ReactEditorJS = createReactEditorJS();

export default class Blocks extends React.Component {
	constructor(props) {
		super(props);

		let blocks = null;
		
		try {
			blocks = typeof this.props.blocks === 'object' ? this.props.blocks : JSON.parse(this.props.blocks);
		} catch(error) {
			consoleLog(error);
		}
		this.state = {
			blocks,
		};
	}
	async componentDidMount() {
	}
	render() {
		return (
			<>
				<ReactEditorJS
					holder={this.props.id}
					/*tools={Raw}*/
					data={{blocks: this.state.blocks}}
					readOnly={true}
				/>
			</>
		)
	}
}
